require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/registrer/bundlesFloorSlider.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/registrer/bundlesFloorSlider.legacy.js
// module id = 728
// module chunks = 31